"use client";

import { useEffect } from "react";

/** Enregistre le service worker minimal (public/sw.js) — chantier "app
 * installable". Rien à afficher, juste l'effet de bord d'enregistrement au
 * montage. Composant client à part : layout.tsx (Server Component) ne peut
 * pas appeler navigator.serviceWorker directement. */
export function ServiceWorkerRegister() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js").catch(() => {
        // Échec silencieux : l'app fonctionne très bien sans SW, seule
        // l'installabilité en pâtit — jamais bloquant pour l'utilisatrice.
      });
    }
  }, []);

  return null;
}
